import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import BrandLogo from "@/components/BrandLogo";

const PAGE_X = "px-5 sm:px-6";

const NAV_LINKS = [
    { label: "Features", hash: "features" },
    { label: "How it works", hash: "how" },
    { label: "Pricing", hash: "pricing" },
];

const linkClass = (active) =>
    active
        ? "text-[#C84B31] font-semibold"
        : "text-[#5C4033]/80 transition-colors hover:text-[#C84B31]";

export default function LandingHeader() {
    const { pathname } = useLocation();
    const onHome = pathname === "/";
    const onBlog = pathname === "/blog" || pathname.startsWith("/blog/");

    const sectionHref = (hash) => (onHome ? `#${hash}` : `/#${hash}`);

    return (
        <header className="sticky top-0 z-30 border-b border-[#E8E4DE]/80 bg-[#FAF9F6]/92 backdrop-blur-md">
            <div className={`mx-auto flex h-16 max-w-7xl items-center justify-between ${PAGE_X}`}>
                <Link to="/">
                    <BrandLogo
                        textClass="font-serif text-xl font-semibold text-[#4A0E17]"
                        accentClass="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#C84B31]"
                    />
                </Link>
                <nav className="hidden items-center gap-8 text-sm font-medium md:flex">
                    {NAV_LINKS.map(({ label, hash }) => (
                        <a key={hash} href={sectionHref(hash)} className={linkClass(false)}>
                            {label}
                        </a>
                    ))}
                    <Link to="/blog" className={linkClass(onBlog)}>
                        Blog
                    </Link>
                </nav>
                <div className="flex items-center gap-2">
                    <Link to="/login" data-testid="nav-login">
                        <Button variant="ghost" size="sm" className="text-[#3D2817] hover:bg-[#F5F0E8]">
                            Sign in
                        </Button>
                    </Link>
                    <Link to="/register" data-testid="nav-register">
                        <Button size="sm" className="bg-[#4A0E17] shadow-sm hover:bg-[#3b0b12]">
                            Start free trial
                        </Button>
                    </Link>
                </div>
            </div>
        </header>
    );
}
